// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1zdKQ","navbar":"style_navbar__1MQ0S","sidebar":"style_sidebar__GBzY0","switch":"style_switch__2Evh2"};